import React from 'react';
import PropTypes from 'prop-types';
import './SelectionLine.scss';

export default function SelectionLine(props) {
  const {showLine} = props;
  return <div id="selectionLine" className={`selectionLine ${showLine ? 'show' : ''}`} />;
}

SelectionLine.propTypes = {
  showLine: PropTypes.bool,
};

SelectionLine.defaultProps = {
  showLine: false,
};
